import api from './api';
import type { Venue, PaginatedResponse } from '../types/venue';

const BASE = '/admin/venue';

const venueService = {
  /**
   * Get all venues with optional search and filters.
   * TODO Phase 2: wire to real endpoint.
   */
  getAllVenues: async (
    page = 1,
    pageSize = 20,
    sort = 'name',
    order: 'asc' | 'desc' = 'asc',
    searchQuery?: string,
    type?: string,
    status?: string
  ): Promise<PaginatedResponse<Venue>> => {
    const params: Record<string, unknown> = { page, pageSize, sort, order };
    if (searchQuery?.trim()) params.q = searchQuery.trim();
    if (type) params.type = type;
    if (status) params.status = status;
    const response = await api.get(BASE, { params });
    return response.data;
  },

  /** Get a single venue by ID. TODO Phase 2. */
  getVenue: async (venueId: string): Promise<Venue> => {
    const response = await api.get(`${BASE}/${venueId}`);
    return response.data;
  },

  /** Create a new venue. TODO Phase 2. */
  createVenue: async (
    data: Omit<Venue, '_id' | 'createdAt' | 'updatedAt'>
  ): Promise<Venue> => {
    const response = await api.post(BASE, data);
    return response.data;
  },

  /** Update an existing venue. TODO Phase 2. */
  updateVenue: async (
    venueId: string,
    data: Partial<Omit<Venue, '_id' | 'createdAt' | 'updatedAt'>>
  ): Promise<Venue> => {
    const response = await api.put(`${BASE}/${venueId}`, data);
    return response.data;
  },

  /** Delete a venue. TODO Phase 2. */
  deleteVenue: async (venueId: string): Promise<void> => {
    await api.delete(`${BASE}/${venueId}`);
  },
};

export default venueService;
